import PropTypes from "prop-types"

export const PagePropTypes = {
  config: PropTypes.shape({
    appENV: PropTypes.string
  })
}

export const PageDefaultProps = {
  config: {
    appENV: ""
  }
}

export const WithMainLayoutPropTypes = {
  WrappedComponent: PropTypes.elementType,
  hocOptions: PropTypes.shape({
    pageTitle: PropTypes.string,
    withoutTitle: PropTypes.bool,
    TopMessage: PropTypes.elementType
  })
}

export const WithMainLayoutDefaultProps = {
  hocOptions: { pageTitle: "", withoutTitle: false, TopMessage: null }
}
